<progress [value]="progressValue" [max]="100" [class]="color()!"></progress>
